import { CdkAccordionModule } from '@angular/cdk/accordion'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatTableModule } from '@angular/material/table'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'

import { ChartsModule } from '../../charts/charts.module'
import { PortfolioHoldingsSortPipe } from '../shared/pipes/portfolio-holdings-sort.pipe'
import { SharedModule } from '../shared/shared.module'
import { AllocationToUnderlyingfundsComponent } from './components/allocation-to-underlyingfunds/allocation-to-underlyingfunds.component'
import { AssetAllocationChartComponent } from './components/asset-allocation-chart/asset-allocation-chart.component'
import { BalancedRiskComponent } from './components/balanced-risk/balanced-risk.component'
import { CharacteristicsContianerComponent } from './components/characteristics-contianer/characteristics-contianer.component'
import { EquityCharacteristicComponent } from './components/equity-characteristic/equity-characteristic.component'
import { FixedIncomeCharacteristicComponent } from './components/fixed-income-characteristic/fixed-income-characteristic.component'
import { FundCharacteristicComponent } from './components/fund-characteristic/fund-characteristic.component'
import { HoldingDetailsContainerComponent } from './components/holding-details/holding-details-container/holding-details-container.component'
import { HoldingDetailsPaginationComponent } from './components/holding-details/holding-details-pagination/holding-details-pagination.component'
import { HoldingDetailsResultsComponent } from './components/holding-details/holding-details-results/holding-details-results.component'
import { DateRangeSelectComponent } from './components/holding-details/money-market/date-range-select/date-range-select.component'
import { MoneyMarketCharacteristicResultsComponent } from './components/holding-details/money-market/money-market-characteristic-results/money-market-characteristic-results.component'
import { MoneyMarketResultsComponent } from './components/holding-details/money-market/money-market-results/money-market-results.component'
import { VisitorLegalTermsComponent } from './components/holding-details/money-market/visitor-legal-terms/visitor-legal-terms.component'
import { PcfContainerComponent } from './components/holding-details/portfolio-composition-file/pcf-container/pcf-container.component'
import { PcfResultsComponent } from './components/holding-details/portfolio-composition-file/pcf-results/pcf-results.component'
import { ScrollButtonComponent } from './components/holding-details/scroll-button/scroll-button.component'
import { LiquidAssetComponent } from './components/liquid-asset/liquid-asset.component'
import { MoneyMarketCharacteristicComponent } from './components/money-market-characteristic/money-market-characteristic.component'
import { RiskDisclaimerComponent } from './components/risk-disclaimer/risk-disclaimer.component'
import { StyleBoxingComponent } from './components/style-boxing/style-boxing.component'
import { TopTenHoldingsComponent } from './components/top-ten-holdings/top-ten-holdings.component'
import { WeightingExposureComponent } from './components/weighting-exposure/weighting-exposure.component'
import { PortfolioComponent } from './portfolio.component'
import { PortfolioService } from './portfolio.service'

@NgModule({
  declarations: [
    PortfolioComponent,
    HoldingDetailsPaginationComponent,
    HoldingDetailsResultsComponent,
    HoldingDetailsContainerComponent,
    EquityCharacteristicComponent,
    StyleBoxingComponent,
    FixedIncomeCharacteristicComponent,
    FundCharacteristicComponent,
    WeightingExposureComponent,
    RiskDisclaimerComponent,
    AssetAllocationChartComponent,
    MoneyMarketResultsComponent,
    MoneyMarketCharacteristicResultsComponent,
    DateRangeSelectComponent,
    MoneyMarketCharacteristicComponent,
    AllocationToUnderlyingfundsComponent,
    VisitorLegalTermsComponent,
    PcfContainerComponent,
    PcfResultsComponent,
    CharacteristicsContianerComponent,
    LiquidAssetComponent,
    ScrollButtonComponent,
    BalancedRiskComponent,
    TopTenHoldingsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ChartsModule,
    MatTableModule,
    NgbModule,
    FormsModule,
    MatExpansionModule,
    CdkAccordionModule,
    ReactiveFormsModule,
  ],
  exports: [PortfolioComponent, CdkAccordionModule, MatExpansionModule],
  providers: [PortfolioService, PortfolioHoldingsSortPipe],
})
export class PortfolioModule {}
